import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import Slide1 from "../Images/slide1.png";
import Slide2 from "../Images/slide2.jpg";
import Slide3 from "../Images/slide3.jpg";
import Slide4 from "../Images/slide4.jpg";
import "../CSS/footer.css";

const CarouselSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setActiveIndex(selectedIndex);
  };

  useEffect(() => {
    const textElement = document.querySelector(
      `.animated-text[data-index="${activeIndex}"]`
    );
    if (textElement) {
      textElement.classList.add("show");
    }

    return () => {
      if (textElement) {
        textElement.classList.remove("show");
      }
    };
  }, [activeIndex]);

  return (
    <>
      <Carousel fade activeIndex={activeIndex} onSelect={handleSelect}>
        <Carousel.Item interval={3000} style={{ position: "relative" }}>
          <div className="animated-text">
            <marquee
              width="50%"
              direction="left"
              height="100px"
              scrollamount="14"
            >
              <h1 className="text-white fs-1">Welcome to Bar Association</h1>
            </marquee>
          </div>
          <img src={Slide1} className="d-block w-100" alt="First slide" />
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item>
        {/* <Carousel.Item interval={1000}>
          <img src={Slide2} className="d-block w-100" text="Second slide" />
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item interval={1000}>
          <img src={Slide3} className="d-block w-100" text="Third slide" />
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item interval={1000}>
          <img src={Slide4} className="d-block w-100" text="Fourth slide" />
          <Carousel.Caption></Carousel.Caption>
        </Carousel.Item> */}
      </Carousel>
    </>
  );
};

export default CarouselSlider;
